import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import "./LandingPage.css";
import cardClientSearch from "../../assets/card_client_search.png";
import cardClientBook from "../../assets/card_client_book.png";
import cardClientBudget from "../../assets/card_client_budget.png";
import cardArtistPortfolio from "../../assets/card_artist_portfolio.png";
import cardArtistAgenda from "../../assets/card_artist_agenda.png";
import cardArtistProfit from "../../assets/card_artist_profit.png";
import cardStudioProfessionals from "../../assets/card_studio_professionals.png";
import cardStudioAgenda from "../../assets/card_studio_agenda.png";
import cardStudioCommission from "../../assets/card_studio_commission.png";

import { isStandalone } from "../../utils/pwaUtils";

const LandingPage = () => {
  const { t } = useTranslation();
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate("/home", { replace: true });
    } else if (isStandalone()) {
      navigate("/login", { replace: true });
    }
  }, [token, navigate]);

  const [activeIndex, setActiveIndex] = useState(null);
  const [activeTab, setActiveTab] = useState("clientes");

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="landing-page">
      <Navbar />

      <header className="hero-header">
        <div className="hero-content">
          <h1 className="hero-title">
            {t('hero_title_part1')} <span className="highlight">{t('hero_title_part2')}</span>
          </h1>
          <p className="hero-subtitle">
            {t('hero_subtitle')}
          </p>
          <button className="cta-button">{t('explore_now')}</button>
        </div>
      </header>

      <section className="benefits-section">
        <h3 className="section-title">{t('advantages_title')}</h3>
        <div className="tabs">
          <button
            className={`tab-button ${activeTab === "clientes" ? "active" : ""}`}
            onClick={() => handleTabChange("clientes")}
          >
            {t('for_clients')}
          </button>
          <button
            className={`tab-button ${activeTab === "artistas" ? "active" : ""}`}
            onClick={() => handleTabChange("artistas")}
          >
            {t('for_artists')}
          </button>
          <button
            className={`tab-button ${activeTab === "estudios" ? "active" : ""}`}
            onClick={() => handleTabChange("estudios")}
          >
            {t('for_studios')}
          </button>
        </div>

        {/* Para os Clientes */}
        <div
          className={`tab-content ${activeTab === "clientes" ? "active" : ""}`}
        >
          <div className="tab-description">
            <img
              src={cardClientSearch}
              alt="Clientes"
              className="tab-image"
            />
            <div className="tab-text">
              <h5>{t('find_artists_title')}</h5>
              <p>{t('find_artists_desc')}</p>
            </div>
          </div>
          <div className="tab-description">
            <img
              src={cardClientBook}
              alt="Agendamento de Sessões"
              className="tab-image"
            />
            <div className="tab-text">
              <h5>{t('book_session_title')}</h5>
              <p>{t('book_session_desc')}</p>
            </div>
          </div>
          <div className="tab-description">
            <img
              src={cardClientBudget}
              alt="Orçamentos"
              className="tab-image"
            />
            <div className="tab-text">
              <h5>{t('request_quote_title')}</h5>
              <p>{t('request_quote_desc')}</p>
            </div>
          </div>
        </div>

        {/* Para os Artistas */}
        <div
          className={`tab-content ${activeTab === "artistas" ? "active" : ""}`}
        >
          <div className="tab-description">
            <img
              src={cardArtistPortfolio}
              alt="Divulgação do Artista"
              className="tab-image"
            />
            <div className="tab-text">
              <h5>{t('promote_work_title')}</h5>
              <p>{t('promote_work_desc')}</p>
            </div>
          </div>
          <div className="tab-description">
            <img
              src={cardArtistAgenda}
              alt="Gerenciamento de Agenda"
              className="tab-image"
            />
            <div className="tab-text">
              <h5>{t('manage_schedule_title')}</h5>
              <p>{t('manage_schedule_desc')}</p>
            </div>
          </div>
          <div className="tab-description">
            <img
              src={cardArtistProfit}
              alt="Controle de Lucros"
              className="tab-image"
            />
            <div className="tab-text">
              <h5>{t('control_profit_title')}</h5>
              <p>{t('control_profit_desc')}</p>
            </div>
          </div>
        </div>

        {/* Para os Estúdios */}
        <div
          className={`tab-content ${activeTab === "estudios" ? "active" : ""}`}
        >
          <div className="tab-description">
            <img
              src={cardStudioProfessionals}
              alt="Gerenciamento de Profissionais"
              className="tab-image"
            />
            <div className="tab-text">
              <h5>{t('manage_pros_title')}</h5>
              <p>{t('manage_pros_desc')}</p>
            </div>
          </div>
          <div className="tab-description">
            <img
              src={cardStudioAgenda}
              alt="Controle de Agendas"
              className="tab-image"
            />
            <div className="tab-text">
              <h5>{t('control_schedules_title')}</h5>
              <p>{t('control_schedules_desc')}</p>
            </div>
          </div>
          <div className="tab-description">
            <img
              src={cardStudioCommission}
              alt="Gestão de Comissões"
              className="tab-image"
            />
            <div className="tab-text">
              <h5>{t('commission_mgmt_title')}</h5>
              <p>{t('commission_mgmt_desc')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="faq-section">
        <h3 className="section-title">{t('faq_title')}</h3>
        <div className="faq-item">
          <button onClick={() => toggleFAQ(1)} className="faq-question">
            {t('faq_q1')}
          </button>
          <div className={`faq-answer ${activeIndex === 1 ? "active" : ""}`}>
            <p>
              {t('faq_a1')}
            </p>
          </div>
        </div>
        <div className="faq-item">
          <button onClick={() => toggleFAQ(2)} className="faq-question">
            {t('faq_q2')}
          </button>
          <div className={`faq-answer ${activeIndex === 2 ? "active" : ""}`}>
            <p>
              {t('faq_a2')}
            </p>
          </div>
        </div>
      </section>

      <section className="disclaimer-section-footer">
        <div className="container">
          <p>{t('system_disclaimer')}</p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LandingPage;
